import { ElementRef } from '@angular/core';

export class QaroniHtmlLegendPlugin {
  public id: 'htmlLegendPlugin';
  private legendContainer: ElementRef<HTMLElement>;
  private type: 'circle' | 'line';

  constructor(
    legendContainer: ElementRef<HTMLElement>,
    type: 'circle' | 'line' = 'circle'
  ) {
    this.legendContainer = legendContainer;
    this.type = type;
  }

  public getOrCreateLegendList() {
    const legendContainer = this.legendContainer.nativeElement;
    let listContainer = legendContainer.querySelector('ul');

    if (!listContainer) {
      listContainer = document.createElement('ul');
      listContainer.classList.add('flex', 'flex-col', 'items-start', 'gap-2.5');

      legendContainer.appendChild(listContainer);
    }

    return listContainer;
  }

  afterUpdate(chart) {
    const ul = this.getOrCreateLegendList();

    while (ul.firstChild) {
      ul.firstChild.remove();
    }

    const items = chart.options.plugins.legend.labels.generateLabels(chart);

    items.forEach(item => {
      const li = document.createElement('li');

      li.classList.add(
        'flex',
        this.type == 'line' ? 'flex-col' : 'flex-row',
        this.type == 'line' ? 'items-start' : 'items-center',
        'cursor-pointer',
        this.type == 'line' ? 'gap-0' : 'gap-2.5',
        'w-full'
      );

      li.onclick = () => {
        const { type } = chart.config;
        if (type === 'pie' || type === 'doughnut') {
          chart.toggleDataVisibility(item.index);
        } else {
          chart.setDatasetVisibility(
            item.datasetIndex,
            !chart.isDatasetVisible(item.datasetIndex)
          );
        }
        chart.update();
      };

      const indicatorSpan = document.createElement('span');
      indicatorSpan.style.background = item.strokeStyle;
      if (this.type === 'circle') {
        indicatorSpan.classList.add('h-3', 'w-3', 'rounded-full', 'shrink-0');
      }
      if (this.type === 'line') {
        indicatorSpan.style.height = '4px';
        indicatorSpan.classList.add('w-full', 'shrink-0');
      }

      const textContainer = document.createElement('p');
      textContainer.style.color = item.fontColor;
      textContainer.style.textDecoration = item.hidden ? 'line-through' : '';
      textContainer.classList.add('m-0', 'p-0', 'w-full');

      const text = document.createTextNode(item.text);
      textContainer.appendChild(text);

      if (this.type === 'line') {
        li.appendChild(textContainer);
        li.appendChild(indicatorSpan);
      } else {
        li.appendChild(indicatorSpan);
        li.appendChild(textContainer);
      }
      ul.appendChild(li);
    });
  }
}
